export const FieldTypes = {
    TEXT_FIELD: 'TEXT_FIELD',
    TEXT_AREA: 'TEXT_AREA',
    SELECT_FIELD: 'SELECT_FIELD',
    PHONE_FIELD: 'PHONE_FIELD',
    NUMBER_FIELD: 'NUMBER_FIELD',
    PASSWORD_FIELD: 'PASSWORD_FIELD'
}